import React, { useCallback, useEffect, useState } from 'react';
import { fabric } from 'fabric';
import { errorCatch, FieldMobile, GET, JSX, useAuth, useUserContext, ycStorage, pushStateHistoryModal, useNavigation, JSXMap } from 'fennec-ui';
import Icofont from 'react-icofont';
import './index.css';
import { SwapOutlined } from '@ant-design/icons';
import Color from '../Color';
import { ycBucket } from '../../../common/Tool';
import { Button, Popup, Radio, Selector } from 'antd-mobile';
import { PictureOutline, UserAddOutline } from 'antd-mobile-icons'


var FontFaceObserver = require('fontfaceobserver');

function Editor(props) {
    const { avatarTextKind, template, viewWidth, saveWidth, aspectRatioID, multiplier, admin, event } = props;

    const auth = useAuth();
    const user = useUserContext();
    const navigation = useNavigation();

    const textX = -400;//70 * 3;
    const textY = 200;//275 * 3;
    const textFontSize = 50;

    const textX2 = -290;
    const textY2 = 270;
    const textFontSize2 = 50;

    const textX3 = -180;
    const textY3 = 340;
    const textFontSize3 = 50;

    const [object, setObject] = useState({
        visibleLastname: false,
        visibleFirstname: false,
        visibleKind: false,
        lastname: true,
        firstname: true,
        kind: true,

        lastnameColor: "white",
        firstnameColor: "white",
        kindColor: "white",
        firstnameX: textX,
        firstnameY: textY,
        firstnameFontSize: textFontSize,
        lastnameX: textX2,
        lastnameY: textY2,
        lastnameFontSize: textFontSize2,
        kindX: textX3,
        kindY: textY3,
        kindFontSize: textFontSize3,
        lastnameText: user.lastname,
        firstnameText: user.firstname,
        // kindText: 1,
        angle: 0,
    });

    // const [kindData, setKindData] = useState([
    //     // { ID: 1, name: "Организатор" },
    //     // { ID: 2, name: "Судья" },
    //     // { ID: 3, name: "Я иду!" },
    //     // { ID: 4, name: "Я в теме!" },
    //     // { ID: 5, name: "DJ" },
    // ]);
    const [canvas, setCanvas] = useState();
    const [photo, setPhoto] = useState();
    const [image, setImage] = useState();
    const [kind, setKind] = useState();
    const [lastname, setLastname] = useState();
    const [firstname, setFirstname] = useState();
    const [fontLoad, setFontLoad] = useState(false);
    const [avatarTextSettings, setAvatarTextSettings] = useState();

    const canvasWidth = saveWidth;
    const canvasHeight = canvasWidth * multiplier;

    const preparePhoto = (photo) => {
        photo.centeredScaling = true;
        photo.lockScalingFlip = true
        photo.transparentCorners = false;
        photo.borderColor = 'black'
        photo.cornerColor = 'black'
        photo.cornerStrokeColor = 'black'
        photo.cornerSize = 40
        photo.setControlVisible('ml', false)
        photo.setControlVisible('mb', false)
        photo.setControlVisible('mr', false)
        photo.setControlVisible('mt', false)
        // photo.setControlVisible('mtr', false)
        photo.controls.mtr.offsetY = -25
        photo.controls.mtr.render = function (ctx, left, top, styleOverride, fabricObject) {
            var image = new Image(50, 50), x, y;
            image.src = '/resources/ui-rotation.svg';
            x = left - image.width / 2;
            y = top - image.height / 2;
            ctx.drawImage(image, x, y, 50, 50);

            // styleOverride = styleOverride || {};
            // fabric.controlsUtils.renderCircleControl.call(this, ctx, left, top, styleOverride, fabricObject);
        }

        photo.on('mouseover', function (e) {
            if (photo.canvas) {
                var canvas = photo.canvas
                canvas.setActiveObject(photo)
                if (canvas.overlayImage) {
                    canvas.overlayImage.set('opacity', 0.65);
                }
                canvas.renderAll();
            }
        });

        photo.on('mouseout', function (e) {
            if (photo.canvas) {
                var canvas = photo.canvas
                if (canvas.overlayImage) {
                    canvas.overlayImage.set('opacity', 1);
                }
                canvas.renderAll();
            }
        });

        photo.on('mousewheel', function (e) {
            if (e && e.e) {
                e.e.preventDefault();
                if (e.e.deltaY < 0) {
                    zoomIn(photo);
                } else if (e.e.deltaY > 0) {
                    zoomOut(photo);
                }
            }
        });

        photo.controls.mtr.mouseUpHandler = function (e, transform) {
            if (transform && transform.target) {
                var angle = transform.target.angle || 0;
                if (angle > 180) {
                    angle -= 360
                }
                setObject(o => ({ ...o, angle: angle }))
            }
        };
    }

    //Поворот и масштабирование пальцами на телефоне
    const touchScaleRotateOn = (canvas) => {
        let touchstart = false
        let startLen = undefined
        let startAngle = undefined
        let startActiveObjectScale = undefined
        let startActiveObjectAngle = undefined
        let startQuarter = undefined
        let touchend = false
        let touch0Idx = 0
        let touch1Idx = 1
        canvas.upperCanvasEl.addEventListener("touchstart", (e) => {
            if (e?.touches?.length == 2 && canvas?.getActiveObject()) {
                touchstart = true
                touchend = false

                startActiveObjectScale = canvas.getActiveObject().scaleX
                startActiveObjectAngle = canvas.getActiveObject().angle

                touch0Idx = 0
                touch1Idx = 1
                if (e.touches[1].pageX < e.touches[0].pageX) {
                    touch0Idx = 1
                    touch1Idx = 0
                }

                startLen = Math.sqrt(Math.pow(e.touches[touch0Idx].pageX - e.touches[touch1Idx].pageX, 2) + Math.pow(e.touches[touch0Idx].pageY - e.touches[touch1Idx].pageY, 2))
                let angle = Math.atan(Math.abs(e.touches[touch0Idx].pageY - e.touches[touch1Idx].pageY) / Math.abs(e.touches[touch0Idx].pageX - e.touches[touch1Idx].pageX)) * 180 / Math.PI;

                //Определяем началную четверь, она может быть 0 или 3 (удобнее именно 3 а не 1, хотя можно и 1)
                //Так как на старте в touch0Idx.pageX всегда <= touch1Idx.pageX, то по оси X проверку не делаем
                if (e.touches[touch0Idx].pageY >= e.touches[touch1Idx].pageY) {
                    startQuarter = 0
                } else {
                    angle = Math.abs(angle - 90)
                    startQuarter = 3
                }
                startAngle = angle + 90 * startQuarter
                // console.log("touchstart", e, startLen, angle, startQuarter, startAngle) 
            }
        }, false);
        canvas.upperCanvasEl.addEventListener("touchend", (e) => {
            if (touchstart && e?.touches?.length != 2) {
                touchstart = false
                touchend = true
            }
        }, false);
        // canvas.upperCanvasEl.addEventListener("touchcancel", (e) => { console.log(e) }, false);
        let lastAngle = 0;
        canvas.upperCanvasEl.addEventListener("touchmove", (e) => {
            if (e?.touches?.length == 2 && canvas?.getActiveObject()) {

                let l = Math.sqrt(Math.pow(e.touches[touch0Idx].pageX - e.touches[touch1Idx].pageX, 2) + Math.pow(e.touches[touch0Idx].pageY - e.touches[touch1Idx].pageY, 2))
                let angle = Math.atan(Math.abs(e.touches[touch0Idx].pageY - e.touches[touch1Idx].pageY) / Math.abs(e.touches[touch0Idx].pageX - e.touches[touch1Idx].pageX)) * 180 / Math.PI;

                //Масштаб
                if (startLen) {
                    let x = (startActiveObjectScale * l) / startLen
                    // console.log(startActiveObjectScale, startLen, l, l-startLen, x)
                    canvas.getActiveObject().scale(x)
                    canvas.renderAll()
                }

                //Поворот
                if (Math.trunc(angle) != lastAngle) {
                    lastAngle = Math.trunc(angle);

                    if (lastAngle % 1 == 0) {

                        //Нумеруем четверти против часовой стрелки начиная с 0. Нулевая четверть левая верхняя.
                        //Для четвертей 1 и 3 арктангенс возвращает угол начиная с 90 а не с 0, меняем это на от 0 до 90 (lastAngle = Math.abs(lastAngle - 90))
                        let quarter = 0
                        if (e.touches[touch0Idx].pageX <= e.touches[touch1Idx].pageX && e.touches[touch0Idx].pageY >= e.touches[touch1Idx].pageY) {
                            quarter = 0
                        } else if (e.touches[touch0Idx].pageX > e.touches[touch1Idx].pageX && e.touches[touch0Idx].pageY >= e.touches[touch1Idx].pageY) {
                            lastAngle = Math.abs(lastAngle - 90)
                            quarter = 1
                        } else if (e.touches[touch0Idx].pageX > e.touches[touch1Idx].pageX && e.touches[touch0Idx].pageY < e.touches[touch1Idx].pageY) {
                            quarter = 2
                        } else if (e.touches[touch0Idx].pageX <= e.touches[touch1Idx].pageX && e.touches[touch0Idx].pageY < e.touches[touch1Idx].pageY) {
                            lastAngle = Math.abs(lastAngle - 90)
                            quarter = 3
                        }

                        //Текущий угол с учетом четвтерти
                        var currentAngle = lastAngle + 90 * quarter
                        //Рассчитанный угол на который нужно повернуть объект
                        var calcAngleRotate = currentAngle - startAngle

                        // console.log("touchmove", l, lastAngle, currentAngle, startAngle, calcAngleRotate) 

                        canvas.getActiveObject().angle = startActiveObjectAngle - calcAngleRotate
                        canvas.renderAll()
                    }
                }
            }
        }, false);
    }

    useEffect(() => {
        let canvas = new fabric.Canvas('canvas', {
            enableRetinaScaling: false,
            height: canvasHeight,
            width: canvasWidth,
            backgroundColor: 'white',
            alignSelf: "center",
        });

        touchScaleRotateOn(canvas);

        // const csize = "calc(100vw - 20px)";

        canvas.lowerCanvasEl.style.width = `calc(100vw - 20px)`;
        canvas.lowerCanvasEl.style.height = `calc(100vw * ${multiplier} - 20px)`;
        canvas.upperCanvasEl.style.width = `calc(100vw - 20px)`;
        canvas.upperCanvasEl.style.height = `calc(100vw * ${multiplier} - 20px)`;
        canvas.wrapperEl.style.width = `calc(100vw - 20px)`;
        canvas.wrapperEl.style.height = `calc(100vw * ${multiplier} - 20px)`;

        canvas.allowTaint = true;

        setCanvas(canvas);

        var myfont = new FontFaceObserver('UkrainianCompact')
        myfont.load().then(function () {
            setFontLoad(true)
        })
    }, []);

    useEffect(() => {
        if (avatarTextKind) {
            setObject(o => ({
                ...o,
                image: (template) ? ycStorage(auth) + ycBucket(auth) + "/" + template?.ssilka : undefined,
            }));
            if (template) {
                GET(auth, `/api/avatar-text-settings/list/${template?.ID}`,
                    ({ data }) => {
                        setAvatarTextSettings(data);
                        if (data && data.length) {
                            let ofirstname = data?.find(e => e.name === "firstname");
                            let olastname = data?.find(e => e.name === "lastname");
                            let okind = data?.find(e => e.name === "kind");
                            setObject(o => ({
                                ...o,
                                visibleFirstname: (ofirstname) ? ofirstname.visible : o.visibleFirstname,
                                firstnameX: (ofirstname) ? ofirstname.x : o.firstnameX,
                                firstnameY: (ofirstname) ? ofirstname.y : o.firstnameY,
                                firstnameFontSize: (ofirstname) ? ofirstname.fontSize : o.firstnameFontSize,
                                firstnameColor: (ofirstname) ? ofirstname.color : o.firstnameColor,
                                visibleLastname: (olastname) ? olastname.visible : o.visibleLastname,
                                lastnameX: (olastname) ? olastname.x : o.lastnameX,
                                lastnameY: (olastname) ? olastname.y : o.lastnameY,
                                lastnameFontSize: (olastname) ? olastname.fontSize : o.lastnameFontSize,
                                lastnameColor: (olastname) ? olastname.color : o.lastnameColor,
                                visibleKind: (okind) ? okind.visible : o.visibleKind,
                                kindX: (okind) ? okind.x : o.kindX,
                                kindY: (okind) ? okind.y : o.kindY,
                                kindFontSize: (okind) ? okind.fontSize : o.kindFontSize,
                                kindColor: (okind) ? okind.color : o.kindColor,
                            }));
                        }
                    }, errorCatch)
            }
        }
    }, [template, avatarTextKind]);

    useEffect(() => {
        if (canvas) {
            canvas.upperCanvasEl.addEventListener("touchend", (e) => {
                if (e?.touches?.length == 0) {
                    if (canvas.getActiveObject()) {
                        let angle = canvas.getActiveObject().angle % 360 || 0;
                        if (angle > 180) {
                            angle -= 360
                        } else if (angle < -180) {
                            angle += 360
                        }
                        setObject(o => ({ ...o, angle: angle }))
                    }
                }
            }, false);
        }
    }, [canvas])

    useEffect(() => {
        fabric.Image.fromURL(object.photo, function (img) {
            const properties = img.set({
                originX: "center",
                originY: "center",
                left: canvasWidth / 2,
                top: canvasHeight / 2 + 40,
            });
            if (canvasWidth < canvasHeight) {
                properties.scaleToWidth(canvasWidth, false);
            } else {
                properties.scaleToHeight(canvasHeight, false);
            }
            properties.set('selectable', true);
            preparePhoto(img)
            setPhoto(img);
        }, { crossOrigin: 'Anonymous' });
    }, [object.photo]);
    useEffect(() => {
        if (object.image) {
            fabric.Image.fromURL(object.image, function (img) {
                const properties = img.set({
                    left: 0,
                    top: 0
                });
                if (canvasWidth < canvasHeight) {
                    properties.scaleToWidth(canvasWidth, false);
                } else {
                    properties.scaleToHeight(canvasHeight, false);
                }
                properties.set('selectable', false);
                properties.hasBorders = false;
                properties.hasControls = false;
                setImage(img);
            }, { crossOrigin: 'Anonymous' });
        } else {
            setImage(undefined);
        }
    }, [object.image]);
    useEffect(() => {
        let x = textX;
        let y = textY;
        const properties = new fabric.Text(object.firstnameText || "", { left: x, top: y, fontSize: textFontSize, fontFamily: 'UkrainianCompact', fill: 'white', });
        properties.set('selectable', false);
        properties.hasBorders = false;
        properties.hasControls = false;
        setFirstname(properties);
    }, []);
    useEffect(() => {
        let x = textX;
        let y = textY;
        const properties = new fabric.Text(object.lastnameText || "", { left: x, top: y, fontSize: textFontSize, fontFamily: 'UkrainianCompact', fill: 'white', });
        properties.set('selectable', false);
        properties.hasBorders = false;
        properties.hasControls = false;
        setLastname(properties);
    }, []);
    useEffect(() => {
        let x = textX;
        let y = textY;
        const properties = new fabric.Text("Организатор", { left: x, top: y, fontSize: textFontSize, fontFamily: 'UkrainianCompact', fill: 'white', });
        properties.set('selectable', false);
        properties.hasBorders = false;
        properties.hasControls = false;
        setKind(properties);
    }, []);

    const toLeft = (photo) => {
        if (!photo.canvas) {
            return
        }

        photo.left -= 10;
        photo.canvas.renderAll();
    }
    const toRight = (photo) => {
        if (!photo.canvas) {
            return
        }

        photo.left += 10;
        photo.canvas.renderAll();
    }
    const toUp = (photo) => {
        if (!photo.canvas) {
            return
        }

        photo.top -= 10;
        photo.canvas.renderAll();
    }
    const toDown = (photo) => {
        if (!photo.canvas) {
            return
        }

        photo.top += 10;
        photo.canvas.renderAll();
    }
    const zoomIn = (photo) => {
        if (!photo.canvas) {
            return
        }

        var scaleVal = 50 / (photo.width || 1);
        photo.scaleY += scaleVal
        photo.scaleX += scaleVal
        photo.canvas.renderAll();
    }
    const zoomOut = (photo) => {
        if (!photo.canvas) {
            return
        }

        var scaleVal = 50 / (photo.width || 1);
        photo.scaleY -= scaleVal
        photo.scaleX -= scaleVal
        photo.canvas.renderAll();
    }
    const flipX = (photo) => {
        if (!photo.canvas) {
            return
        }

        photo.flipX = !photo.flipX
        photo.canvas.renderAll();
    }
    const flipY = (photo) => {
        if (!photo.canvas) {
            return
        }

        photo.flipY = !photo.flipY
        photo.canvas.renderAll();
    }

    useEffect(() => {
        if (canvas && object) {
            canvas.clear();

            if (photo) {
                photo.rotate(object.angle || 0)

                canvas.add(photo).sendToBack(photo);
            }

            if (object.visibleFirstname) {
                firstname.text = object.firstnameText || "";
                firstname.set("fill", object.firstnameColor);
                firstname.set("left", object.firstnameX);
                firstname.set("top", object.firstnameY);
                firstname.set("fontSize", object.firstnameFontSize);
            }
            if (object.visibleLastname) {
                lastname.text = object.lastnameText || "";
                lastname.set("fill", object.lastnameColor);
                lastname.set("left", object.lastnameX);
                lastname.set("top", object.lastnameY);
                lastname.set("fontSize", object.lastnameFontSize);
            }
            if (object.visibleKind) {
                let t = (!avatarTextKind) ? "" : avatarTextKind?.find(e => e.ID === object.kindText)?.name;
                kind.text = (t) ? "" + t : "";

                kind.set("fill", object.kindColor);
                kind.set("left", object.kindX);
                kind.set("top", object.kindY);
                kind.set("fontSize", object.kindFontSize);
            }
            firstname.visible = object.visibleFirstname && object.firstname;
            lastname.visible = object.visibleLastname && object.lastname;
            kind.visible = object.visibleKind && object.kind;

            if (image && firstname && lastname && kind) {
                var group = new fabric.Group([image], {
                    left: 0,
                    top: 0,
                });
                canvas.setOverlayImage(group);
                group.add(firstname)
                group.add(lastname)
                group.add(kind)
            }
        }
    }, [canvas, object, photo, image, firstname, lastname, kind, fontLoad]);

    const load = (url) => {
        const reader = new FileReader();
        reader.onload = function (event) {
            const imgObj = new Image();
            imgObj.src = event.target.result;
            imgObj.onload = function () {
                const image = new fabric.Image(imgObj);
                const properties = image.set({
                    originX: "center",
                    originY: "center",
                    left: canvasWidth / 2,
                    top: canvasHeight / 2 + 40,
                });
                if (canvasWidth < canvasHeight) {
                    properties.scaleToWidth(canvasWidth, false);
                } else {
                    properties.scaleToHeight(canvasHeight, false);
                }
                properties.set('selectable', true);
                preparePhoto(properties);
                setPhoto(properties);
                setDisabledDownload(false);
            }
        };
        reader.readAsDataURL(url);
    };

    const [visible1, setVisible1] = useState(false)
    const [visible2, setVisible2] = useState(false)
    const [visible3, setVisible3] = useState(false)

    const [disabledDownload, setDisabledDownload] = useState(true)

    return (
        <>
            <div style={{ paddingBottom: "25px", backgroundColor: "white", borderRadius: "4px" }}>
                {/* {event && <div style={{ fontWeight: "600", padding: "10px 0", fontSize: "18px", textAlign: "center" }}>
                    {event.nazvanieMeropriyatiya}
                </div>} */}
                <div style={{ display: "flex", flexDirection: "column", paddingTop: "10px" }}>
                    <div style={{ padding: "0px 10px 5px 10px", display: "flex", justifyContent: "space-between", gap: "5px" }}>
                        <div style={{ flex: "1" }}>
                            <Button color='default' /*fill='solid'*/ style={{ width: "100%" }} onClick={e => {
                                navigation(-1);
                            }}><Icofont icon="rounded-left" /> Назад</Button>
                        </div>
                        <div style={{ flex: "1", width: "100%" }}>
                            <Button
                                disabled={disabledDownload}
                                color='primary' /*fill='solid'*/ style={{ width: "100%" }} onClick={e => {
                                    let b64 = canvas.toDataURL({
                                        format: 'png',
                                        left: 0,
                                        top: 0,
                                        width: canvasWidth,
                                        height: canvasHeight
                                    });

                                    var a = document.createElement("a");
                                    document.body.appendChild(a);
                                    a.style = "display: none";
                                    a.href = b64;
                                    a.download = "";
                                    a.click();
                                    window.URL.revokeObjectURL(b64);
                                }}>Скачать</Button>
                        </div>
                    </div>
                    <div style={{
                        display: "flex",
                        justifyContent: "center"
                    }}>
                        <canvas id="canvas" />
                    </div>
                    <div style={{ padding: "0px 5px" }}>
                        <div style={{ padding: "5px 0px", width: "100%", display: "flex", justifyContent: "space-between", gap: "10px" }}>
                            <div style={{ flex: "0" }}>
                                <FieldMobile
                                    key={"photo"}
                                    auth={auth}
                                    item={{
                                        label: "Фото",
                                        name: "file",
                                        type: "file",
                                        showUploadList: false,
                                        accept: ".png,.jpg",
                                        header: false,
                                        trigger: () => (<div
                                            style={{
                                                width: 65,
                                                height: 65,
                                                borderRadius: "4px",
                                                backgroundColor: '#f5f5f5',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                color: '#999999',
                                            }}
                                        >
                                            <UserAddOutline style={{ fontSize: 32 }} />
                                            {/* <PictureOutline style={{ fontSize: 32 }} /> */}
                                        </div>)
                                    }}
                                    onChange={files => {
                                        if (files && files.length) {
                                            load(files[0]);
                                        }
                                    }}
                                />
                            </div>
                            <div style={{ padding: "5px 0px", display: "flex", gap: "5px", flexWrap: "wrap" }}>
                                <Button size="small" onClick={() => zoomIn(photo)}><Icofont icon="ui-zoom-in" /></Button>
                                <Button size="small" onClick={() => zoomOut(photo)}><Icofont icon="ui-zoom-out" /></Button>
                                <Button size="small" onClick={() => flipX(photo)}><SwapOutlined /></Button>
                                <Button size="small" onClick={() => flipY(photo)}><SwapOutlined className="icofont-rotate-90" /></Button>
                                <Button size="small" onClick={() => toLeft(photo)}><Icofont icon="long-arrow-left" /></Button>
                                <Button size="small" onClick={() => toRight(photo)}><Icofont icon="long-arrow-right" /></Button>
                                <Button size="small" onClick={() => toUp(photo)}><Icofont icon="long-arrow-up" /></Button>
                                <Button size="small" onClick={() => toDown(photo)}><Icofont icon="long-arrow-down" /></Button>
                            </div>
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                            <div style={{ width: "100%", padding: "5px 10px", marginBottom: "5px", backgroundColor: "rgb(250 250 250)", borderRadius: "4px" }}>
                                <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                    <div style={{ flex: "0" }}>
                                        <Button type="text" size='small' style={{ padding: "2px 5px" }} onClick={v => setObject(o => ({ ...o, angle: 0 }))}>
                                            <Icofont icon="rotation" />
                                        </Button>
                                    </div>
                                    <div style={{ flex: "1" }}>
                                        <FieldMobile
                                            key={"angle"}
                                            auth={auth}
                                            item={{
                                                label: 'Поворот',
                                                name: "angle",
                                                type: "int",
                                                filterType: "slider",
                                                realtime: true,
                                                min: -180,
                                                max: 180,
                                                header: false,
                                            }}
                                            value={object.angle}
                                            onChange={v => setObject(o => ({ ...o, angle: v }))}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div style={{ paddingBottom: "10px", width: "100%", display: "flex", justifyContent: "flex-start", gap: "10px" }}>
                                {object.visibleFirstname && <div style={{ width: "100%" }}>
                                    <Button
                                        style={{ width: "100%" }}
                                        size='small'
                                        onClick={() => {
                                            pushStateHistoryModal(setVisible1);
                                            setVisible1(true)
                                        }}
                                    >
                                        {object.firstnameText}
                                    </Button>
                                    <Popup
                                        visible={visible1}
                                        maskStyle={{ background: "rgba(0, 0, 0, 0.15)" }}
                                        onMaskClick={() => {
                                            window.history.back();
                                            // setVisible1(false)
                                        }}
                                        bodyStyle={{ height: '215px' }}
                                    >
                                        <div style={{ padding: "7px 10px", fontSize: "14px", fontWeight: "600" }}>Параметры текста</div>
                                        <div style={{ width: "100%", padding: "5px 10px", marginBottom: "5px", backgroundColor: "rgb(250 250 250)", borderRadius: "4px" }}>
                                            <div style={{ width: "100%", display: "flex", gap: "7px", justifyContent: (admin) ? "flex-start" : "space-between", alignItems: "flex-start" }}>
                                                <div style={{ flex: "0", padding: "5px 0px" }}>
                                                    <FieldMobile
                                                        key={"firstname"}
                                                        auth={auth}
                                                        item={{
                                                            label: (!admin) ? object.firstnameText : undefined,
                                                            name: "firstname",
                                                            type: "bool",
                                                            header: false,
                                                        }}
                                                        value={object.firstname}
                                                        onChange={v => setObject(o => ({ ...o, firstname: v }))}
                                                    />
                                                </div>
                                                {admin && <div style={{ flex: "1" }}>
                                                    <FieldMobile
                                                        key={"firstnameText"}
                                                        auth={auth}
                                                        item={{
                                                            name: "firstnameText",
                                                            type: "string",
                                                            size: "small",
                                                            header: false,
                                                        }}
                                                        value={object.firstnameText}
                                                        onChange={v => setObject(o => ({ ...o, firstnameText: v }))}
                                                    />
                                                </div>}
                                                <div style={{ flex: "0", padding: "5px 0px" }}>
                                                    <Color
                                                        disabled={!object.firstname}
                                                        value={object.firstnameColor}
                                                        onChange={v => {
                                                            setObject(o => ({ ...o, firstnameColor: v }));
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div style={{ width: "100%" }}>
                                                <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                                    <div style={{ flex: "0" }}>
                                                        <Button type="text" size='small' style={{ padding: "2px 5px" }} onClick={v => setObject(o => ({ ...o, firstnameX: textX }))}>
                                                            X:
                                                        </Button>
                                                    </div>
                                                    <div style={{ flex: "1" }}>
                                                        <FieldMobile
                                                            key={"firstnameX"}
                                                            auth={auth}
                                                            item={{
                                                                label: 'X',
                                                                name: "firstnameX",
                                                                type: "int",
                                                                filterType: "slider",
                                                                realtime: true,
                                                                min: -1000,
                                                                max: 1000,
                                                                view: {
                                                                    disabled: !object.firstname,
                                                                },
                                                                header: false,
                                                            }}
                                                            value={object.firstnameX}
                                                            onChange={v => setObject(o => ({ ...o, firstnameX: v }))}
                                                        />
                                                    </div>
                                                </div>
                                                <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                                    <div style={{ flex: "0" }}>
                                                        <Button type="text" size='small' style={{ padding: "2px 5px" }} onClick={v => setObject(o => ({ ...o, firstnameY: textY }))}>
                                                            Y:
                                                        </Button>
                                                    </div>
                                                    <div style={{ flex: "1" }}>
                                                        <FieldMobile
                                                            key={"firstnameY"}
                                                            auth={auth}
                                                            item={{
                                                                label: 'Y',
                                                                name: "firstnameY",
                                                                type: "int",
                                                                filterType: "slider",
                                                                realtime: true,
                                                                min: -1000,
                                                                max: 1000,
                                                                view: {
                                                                    disabled: !object.firstname,
                                                                },
                                                                header: false,
                                                            }}
                                                            value={object.firstnameY}
                                                            onChange={v => setObject(o => ({ ...o, firstnameY: v }))}
                                                        />
                                                    </div>
                                                </div>
                                                <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                                    <div style={{ flex: "0" }}>
                                                        <Button type="text" size='small' style={{ padding: "2px 5px" }} onClick={v => setObject(o => ({ ...o, firstnameFontSize: textFontSize }))}>
                                                            <Icofont icon="font" />
                                                        </Button>
                                                    </div>
                                                    <div style={{ flex: "1" }}>
                                                        <FieldMobile
                                                            key={"firstnameFontSize"}
                                                            auth={auth}
                                                            item={{
                                                                label: 'Y',
                                                                name: "firstnameFontSize",
                                                                type: "int",
                                                                filterType: "slider",
                                                                realtime: true,
                                                                min: 22 * 2,
                                                                max: 22 * 6,
                                                                view: {
                                                                    disabled: !object.firstname,
                                                                },
                                                                header: false,
                                                            }}
                                                            value={object.firstnameFontSize}
                                                            onChange={v => setObject(o => ({ ...o, firstnameFontSize: v }))}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Popup>
                                </div>}
                                {object.visibleLastname && <div style={{ width: "100%" }}>
                                    <Button
                                        style={{ width: "100%" }}
                                        size='small'
                                        onClick={() => {
                                            pushStateHistoryModal(setVisible2);
                                            setVisible2(true)
                                        }}
                                    >
                                        {object.lastnameText}
                                    </Button>
                                    <Popup
                                        visible={visible2}
                                        maskStyle={{ background: "rgba(0, 0, 0, 0.15)" }}
                                        onMaskClick={() => {
                                            window.history.back();
                                            // setVisible2(false)
                                        }}
                                        bodyStyle={{ height: '215px' }}
                                    >
                                        <div style={{ padding: "7px 10px", fontSize: "14px", fontWeight: "600" }}>Параметры текста</div>
                                        <div style={{ width: "100%", padding: "5px 10px", marginBottom: "5px", backgroundColor: "rgb(250 250 250)", borderRadius: "4px" }}>
                                            <div style={{ width: "100%", display: "flex", gap: "7px", justifyContent: (admin) ? "flex-start" : "space-between", alignItems: "flex-start" }}>
                                                <div style={{ flex: "0", padding: "5px 0px" }}>
                                                    <FieldMobile
                                                        key={"lastname"}
                                                        auth={auth}
                                                        item={{
                                                            label: (!admin) ? object.lastnameText : undefined,
                                                            name: "lastname",
                                                            type: "bool",
                                                            header: false,
                                                        }}
                                                        value={object.lastname}
                                                        onChange={v => setObject(o => ({ ...o, lastname: v }))}
                                                    />
                                                </div>
                                                {admin && <div style={{ flex: "1" }}>
                                                    <FieldMobile
                                                        key={"lastnameText"}
                                                        auth={auth}
                                                        item={{
                                                            name: "lastnameText",
                                                            type: "string",
                                                            size: "small",
                                                            header: false,
                                                        }}
                                                        value={object.lastnameText}
                                                        onChange={v => setObject(o => ({ ...o, lastnameText: v }))}
                                                    />
                                                </div>}
                                                <div style={{ flex: "0", padding: "5px 0px" }}>
                                                    <Color
                                                        disabled={!object.lastname}
                                                        value={object.lastnameColor}
                                                        onChange={v => {
                                                            setObject(o => ({ ...o, lastnameColor: v }));
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div style={{ width: "100%" }}>
                                                <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                                    <div style={{ flex: "0" }}>
                                                        <Button type="text" size='small' style={{ padding: "2px 5px" }} onClick={v => setObject(o => ({ ...o, lastnameX: textX2 }))}>
                                                            X:
                                                        </Button>
                                                    </div>
                                                    <div style={{ flex: "1" }}>
                                                        <FieldMobile
                                                            key={"lastnameX"}
                                                            auth={auth}
                                                            item={{
                                                                label: 'X',
                                                                name: "lastnameX",
                                                                type: "int",
                                                                filterType: "slider",
                                                                realtime: true,
                                                                min: -1000,
                                                                max: 1000,
                                                                view: {
                                                                    disabled: !object.lastname,
                                                                },
                                                                header: false,
                                                            }}
                                                            value={object.lastnameX}
                                                            onChange={v => setObject(o => ({ ...o, lastnameX: v }))}
                                                        />
                                                    </div>
                                                </div>
                                                <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                                    <div style={{ flex: "0" }}>
                                                        <Button type="text" size='small' style={{ padding: "2px 5px" }} onClick={v => setObject(o => ({ ...o, lastnameY: textY2 }))}>
                                                            Y:
                                                        </Button>
                                                    </div>
                                                    <div style={{ flex: "1" }}>
                                                        <FieldMobile
                                                            key={"lastnameY"}
                                                            auth={auth}
                                                            item={{
                                                                label: 'Y',
                                                                name: "lastnameY",
                                                                type: "int",
                                                                filterType: "slider",
                                                                realtime: true,
                                                                min: -1000,
                                                                max: 1000,
                                                                view: {
                                                                    disabled: !object.lastname,
                                                                },
                                                                header: false,
                                                            }}
                                                            value={object.lastnameY}
                                                            onChange={v => setObject(o => ({ ...o, lastnameY: v }))}
                                                        />
                                                    </div>
                                                </div>
                                                <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                                    <div style={{ flex: "0" }}>
                                                        <Button type="text" size='small' style={{ padding: "2px 5px" }} onClick={v => setObject(o => ({ ...o, lastnameFontSize: textFontSize2 }))}>
                                                            <Icofont icon="font" />
                                                        </Button>
                                                    </div>
                                                    <div style={{ flex: "1" }}>
                                                        <FieldMobile
                                                            key={"lastnameFontSize"}
                                                            auth={auth}
                                                            item={{
                                                                label: 'Y',
                                                                name: "lastnameFontSize",
                                                                type: "int",
                                                                filterType: "slider",
                                                                realtime: true,
                                                                min: 22 * 2,
                                                                max: 22 * 6,
                                                                view: {
                                                                    disabled: !object.lastname,
                                                                },
                                                                header: false,
                                                            }}
                                                            value={object.lastnameFontSize}
                                                            onChange={v => setObject(o => ({ ...o, lastnameFontSize: v }))}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Popup>
                                </div>}
                                {object.visibleKind && <div style={{ width: "100%" }}>
                                    <Button
                                        style={{ width: "100%" }}
                                        size='small'
                                        onClick={() => {
                                            pushStateHistoryModal(setVisible3);
                                            setVisible3(true)
                                        }}
                                    >
                                        {JSX(() => {
                                            let t = (!avatarTextKind) ? "" : avatarTextKind?.find(e => e.ID === object.kindText)?.name;
                                            return (t) ? "" + t : <span style={{ fontSize: "12px", fontStyle: "italic", fontWeight: "lighter" }}>Выбрать</span>;
                                        })}
                                    </Button>
                                    <Popup
                                        visible={visible3}
                                        maskStyle={{ background: "rgba(0, 0, 0, 0.15)" }}
                                        onMaskClick={() => {
                                            window.history.back();
                                            // setVisible3(false)
                                        }}
                                        bodyStyle={{ height: '215px' }}
                                    >
                                        <div style={{ padding: "7px 10px", fontSize: "14px", fontWeight: "600" }}>Параметры текста</div>
                                        <div style={{ width: "100%", padding: "5px 10px", marginBottom: "5px", backgroundColor: "rgb(250 250 250)", borderRadius: "4px" }}>
                                            <div style={{ width: "100%", display: "flex", gap: "7px", alignItems: "flex-start" }}>
                                                <div style={{ flex: "0", padding: "5px 0px" }}>
                                                    <FieldMobile
                                                        key={"kind"}
                                                        auth={auth}
                                                        item={{
                                                            // label: 'Организатор',
                                                            name: "kind",
                                                            type: "bool",
                                                            header: false,
                                                        }}
                                                        value={object.kind}
                                                        onChange={v => setObject(o => ({ ...o, kind: v }))}
                                                    />
                                                </div>
                                                <div style={{ flex: "1" }}>
                                                    <FieldMobile
                                                        key={"kindText"}
                                                        auth={auth}
                                                        item={{
                                                            // label: 'Организатор',
                                                            name: "kindText",
                                                            type: "object",
                                                            view: {
                                                                disabled: !object.kind,
                                                            },
                                                            relation: {
                                                                display: (item) => {
                                                                    return item.name
                                                                },
                                                                reference: {
                                                                    data: avatarTextKind,
                                                                }
                                                            },
                                                            size: "small",
                                                            header: false,
                                                        }}
                                                        value={object.kindText}
                                                        onChange={v => setObject(o => ({ ...o, kindText: v }))}
                                                    />
                                                </div>
                                                <div style={{ flex: "0", padding: "5px 0px" }}>
                                                    <Color
                                                        value={object.kindColor}
                                                        onChange={v => setObject(o => ({ ...o, kindColor: v }))}
                                                    />
                                                </div>
                                            </div>
                                            <div style={{ width: "100%" }}>
                                                <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                                    <div style={{ flex: "0" }}>
                                                        <Button type="text" size='small' style={{ padding: "2px 5px" }} onClick={v => setObject(o => ({ ...o, kindX: textX3 }))}>
                                                            X:
                                                        </Button>
                                                    </div>
                                                    <div style={{ flex: "1" }}>
                                                        <FieldMobile
                                                            key={"kindX"}
                                                            auth={auth}
                                                            item={{
                                                                label: 'X',
                                                                name: "kindX",
                                                                type: "int",
                                                                filterType: "slider",
                                                                realtime: true,
                                                                min: -1000,
                                                                max: 1000,
                                                                view: {
                                                                    disabled: !object.kind,
                                                                },
                                                                header: false,
                                                            }}
                                                            value={object.kindX}
                                                            onChange={v => setObject(o => ({ ...o, kindX: v }))}
                                                        />
                                                    </div>
                                                </div>
                                                <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                                    <div style={{ flex: "0" }}>
                                                        <Button type="text" size='small' style={{ padding: "2px 5px" }} onClick={v => setObject(o => ({ ...o, kindY: textY3 }))}>
                                                            Y:
                                                        </Button>
                                                    </div>
                                                    <div style={{ flex: "1" }}>
                                                        <FieldMobile
                                                            key={"kindY"}
                                                            auth={auth}
                                                            item={{
                                                                label: 'Y',
                                                                name: "kindY",
                                                                type: "int",
                                                                filterType: "slider",
                                                                realtime: true,
                                                                min: -1000,
                                                                max: 1000,
                                                                view: {
                                                                    disabled: !object.kind,
                                                                },
                                                                header: false,
                                                            }}
                                                            value={object.kindY}
                                                            onChange={v => setObject(o => ({ ...o, kindY: v }))}
                                                        />
                                                    </div>
                                                </div>
                                                <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                                    <div style={{ flex: "0" }}>
                                                        <Button type="text" size='small' style={{ padding: "2px 5px" }} onClick={v => setObject(o => ({ ...o, kindFontSize: textFontSize3 }))}>
                                                            <Icofont icon="font" />
                                                        </Button>
                                                    </div>
                                                    <div style={{ flex: "1" }}>
                                                        <FieldMobile
                                                            key={"kindFontSize"}
                                                            auth={auth}
                                                            item={{
                                                                label: 'Y',
                                                                name: "kindFontSize",
                                                                type: "int",
                                                                filterType: "slider",
                                                                realtime: true,
                                                                min: 22 * 2,
                                                                max: 22 * 6,
                                                                view: {
                                                                    disabled: !object.kind,
                                                                },
                                                                header: false,
                                                            }}
                                                            value={object.kindFontSize}
                                                            onChange={v => setObject(o => ({ ...o, kindFontSize: v }))}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Popup>
                                </div>}
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default function AvatarEditor(props) {
    const { admin, event } = props;
    const auth = useAuth();
    const user = useUserContext();
    const [avatarTextKind, setAvatarTextKind] = useState([]);

    // Аватарки
    // 2269x2269 | 1:1  | 1:1  
    // 2269x4033 | 9:16 | 1.7777 : 0.5626
    // 1591x531  | 3:1  | 2,996233522 : 0,333752357
    const aspectRatioArray = [
        { ID: 1, key: "1:1", label: "Квадрат", multiplier: 1 / 1, divider: 1 / 1 },
        { ID: 2, key: "9:16", label: "INSTAGRAM", multiplier: 16 / 9, divider: 9 / 16 },
        { ID: 3, key: "3:1", label: "VK", multiplier: 1 / 3, divider: 3 / 1 },
        { ID: 4, key: "3:4", label: "3:4", multiplier: 4 / 3, divider: 3 / 4 },
    ]
    const [aspectRatio, setAspectRatio] = useState(aspectRatioArray[0]);
    const getAvatarTemplateByAspectRatio = (avatarTemplates, aspectRatio) => {
        return avatarTemplates?.find(e => (e.aspectRatio === aspectRatio.ID) || (!e.aspectRatio && aspectRatio.ID === 1));
    }
    const [template, setTemplate] = useState();

    useEffect(() => {
        if (event && event.avatarTemplateMeropriyatie && event.avatarTemplateMeropriyatie.length) {
            let avatarTemplate = getAvatarTemplateByAspectRatio(event.avatarTemplateMeropriyatie, aspectRatio);
            setTemplate(avatarTemplate)
        }
    }, [event, aspectRatio]);
    useEffect(() => {
        if (template) {
            GET(auth, `/api/avatar-text/list/${template?.ID}`,
                ({ data }) => {
                    setAvatarTextKind(data);
                }, errorCatch)
        }
    }, [template])
    return (
        <div style={{ paddingBottom: "25px", backgroundColor: "white" }}>
            {event &&
                <div style={{ display: "flex", justifyContent: "space-between", gap: "15px", alignItems: "center", textAlign: "center" }}>
                    <div style={{ fontWeight: "600", padding: "10px 0", fontSize: "20px", flex: "1" }}>
                    <a href={`/fed/event/${event.ID}`}>{event.nazvanieMeropriyatiya}</a>
                    </div>
                </div>
            }
            {(event?.avatarTemplateMeropriyatie.length > 1) && <div style={{ width: "100%", padding: "5px 0px", marginBottom: "5px", backgroundColor: "rgb(250 250 250)", borderRadius: "4px" }}>
                <Selector
                    columns={(event?.avatarTemplateMeropriyatie && event.avatarTemplateMeropriyatie.length) ? event.avatarTemplateMeropriyatie.length : undefined}
                    options={aspectRatioArray.filter(x => getAvatarTemplateByAspectRatio(event.avatarTemplateMeropriyatie, x)).map(e => {
                        return ({
                            label: e.key,
                            value: e.ID,
                        })
                    })}
                    defaultValue={[aspectRatio?.ID]}
                    onChange={(arr, extend) => setAspectRatio(aspectRatioArray.find(c => c?.ID == parseInt(arr[0])))}
                />
            </div>}
            {aspectRatio && <Editor admin={admin} event={event} key={aspectRatio?.ID} template={template} avatarTextKind={avatarTextKind} viewWidth={376} saveWidth={(aspectRatio.ID != 3) ? 1200 : 2000} aspectRatioID={aspectRatio?.ID} multiplier={aspectRatio?.multiplier} />}
        </div>
    );
}
